import { render, staticRenderFns } from "./CountByDirectionComponent.vue?vue&type=template&id=51fdfeb4&scoped=true&"
import script from "./CountByDirectionComponent.vue?vue&type=script&lang=js&"
export * from "./CountByDirectionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fdfeb4",
  null
  
)

export default component.exports